export default __webpack_public_path__ + "static/media/Prosperity Life Dark.ba68b306.svg";